module.exports = __webpack_public_path__ + "static/media/11NEPAD8.8c8a5732.jpg";